import { render, staticRenderFns } from "./TrainingCalendarFocusHeader.vue?vue&type=template&id=b3c6cd4e&scoped=true&"
import script from "./TrainingCalendarFocusHeader.vue?vue&type=script&lang=ts&"
export * from "./TrainingCalendarFocusHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCalendarFocusHeader.vue?vue&type=style&index=0&id=b3c6cd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c6cd4e",
  null
  
)

export default component.exports